import { useApp } from "@/context/AppContext";
import { todayIST, isPastSlot, fmtDate } from "@/lib/api";

const nextDays = (n) => {
  const base = new Date(todayIST() + "T00:00:00");
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(base);
    d.setDate(base.getDate() + i);
    return d.toLocaleDateString("en-CA");
  });
};

export const SlotPicker = ({ form, set }) => {
  const { t, meta, lang } = useApp();
  const days = nextDays(7);
  const slots = meta?.slots || [];
  const allPast = slots.length && slots.every((s) => isPastSlot(form.date, s.value));
  const pickDate = (d) => set({ date: d, slot: form.slot && isPastSlot(d, form.slot) ? "" : form.slot });

  return (
    <div className="space-y-5">
      <div>
        <p className="mb-2 text-sm font-semibold text-[#0D3B2B]">{t("Pick a date")}</p>
        <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
          {days.map((d, i) => (
            <button key={d} type="button" onClick={() => pickDate(d)} data-testid={`date-chip-${d}`}
              className={`min-w-[78px] shrink-0 rounded-2xl border-2 px-3 py-2 text-center transition-colors ${form.date === d ? "border-[#0D3B2B] bg-[#0D3B2B] text-white" : "border-[#D2E0D8] bg-white text-[#0D3B2B]"}`}>
              <span className="block text-[11px] font-semibold uppercase opacity-80">{i === 0 ? t("Today") : i === 1 ? t("Tomorrow") : ""}</span>
              <span className="block text-sm font-bold">{fmtDate(d, lang)}</span>
            </button>
          ))}
        </div>
        <label className="mt-3 flex items-center gap-2 text-sm text-[#4A6358]">
          {t("Another date:")}
          <input type="date" min={todayIST()} value={form.date} data-testid="date-input"
            onChange={(e) => e.target.value && pickDate(e.target.value < todayIST() ? todayIST() : e.target.value)}
            className="h-10 rounded-xl border border-[#D2E0D8] bg-white px-3 text-[#0D3B2B]" />
        </label>
      </div>
      <div>
        <p className="mb-2 text-sm font-semibold text-[#0D3B2B]">{t("Pick a time slot (8 AM – 8 PM)")}</p>
        <div className="grid grid-cols-2 gap-3">
          {slots.map((s) => {
            const past = isPastSlot(form.date, s.value);
            const on = form.slot === s.value;
            return (
              <button key={s.value} type="button" disabled={past} onClick={() => set({ slot: s.value })} data-testid={`slot-${s.value}`}
                className={`h-14 rounded-2xl border-2 text-sm font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${on ? "border-[#2E9E6B] bg-[#2E9E6B] text-white" : "border-[#D2E0D8] bg-white text-[#0D3B2B]"}`}>
                {s.label}
              </button>
            );
          })}
        </div>
        {allPast ? <p className="mt-3 text-sm font-medium text-[#E05C3A]" data-testid="slots-past-msg">{t("All slots for today are over. Please pick tomorrow or a later date.")}</p> : null}
      </div>
    </div>
  );
};
